import { bindable } from 'aurelia';

export class Spinner {
    @bindable public busy: boolean = false;
}
